export default __webpack_public_path__ + "media/images/features/local_delivery/episode5/LP_01-1d2a8489a966b596a8093155e73b6de0.jpeg";